'use client'

import ErrorPage from '@layoutpage/error'
export default ErrorPage